import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';

import './styles.css';

export default function Anuncio() {
  const { t } = useTranslation();
  const history = useHistory();
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL');

  const [mensagem, setMensagem] = useState('');
  const [titulo, setTitulo] = useState('');
  const [annoucement_time, setAnnoucement_time] = useState(15);
  const [tag, setTag] = useState('');
  const [tagAn, setTagAn] = useState([]);
  const [urlimg, setUrlimg] = useState('');
  const [phone, setPhone] = useState('');
  const [city_code, setCity_code] = useState(0);
  const [state_code, setState_code] = useState(0);
  const [cidades, setCidades] = useState([]);
  const [nomeCidade, setNomeCidade] = useState('');
  const [livestock_race, setLivestock_race] = useState('');
  const [count, setCount] = useState(0.0);
  const [livestock_age, setLivestock_age] = useState(0);
  const [livestock_weight, setLivestock_weight] = useState(0);
  const [value, setValue] = useState(0);
  const [count_type, setCount_type] = useState('fifteen_kilos');
  const [obs, setObs] = useState('');
  const [erros, setErros] = useState([]);
  const [success, setSuccess] = useState(false);
  const [sending, setSending] = useState(false);
  const [has_video, setHas_video] = useState('');

  function tagsBovinas(lista) {
    if (!Array.isArray(lista)) return [];
    return lista
      .filter((item) => item && item.is_bovine === true)
      .map((item) => ({ id: item.id, name: item.name, slug: item.slug }));
  }

  useEffect(() => {
    try {
      setTagAn(tagsBovinas(JSON.parse(sessionStorage.getItem('TAGS'))));
    } catch (err) {
      setTagAn([]);
    }

    api.get('/v4/tags', {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      const data = Array.isArray(response.data) ? response.data : [];
      sessionStorage.setItem('TAGS', JSON.stringify(data));
      setTagAn(tagsBovinas(data));
    }).catch(() => {});
  }, [USER_EMAIL, USER_TOKEN]);

  async function enviarAnuncio(event) {
    event.preventDefault();
    setErros([]);
    setSuccess(false);

    const data = new FormData();
    data.append('title', titulo);
    data.append('description', mensagem);
    data.append('phone', phone);
    data.append('category', tag);
    data.append('value', value);
    data.append('observation', obs);
    data.append('has_video', has_video);
    data.append('image', document.getElementById('fileInput').files[0]);
    data.append('annoucement_time', annoucement_time);
    data.append('count', count);
    data.append('count_type', count_type);
    data.append('livestock_weight', livestock_weight);
    data.append('livestock_race', livestock_race);
    data.append('livestock_age', livestock_age);
    data.append('city_code', city_code);
    data.append('state_code', state_code);

    setSending(true);
    axios({
      method: 'post',
      url: BASE_URL + '/v6/classifieds',
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        'Content-Type': 'multipart/form-data'
      },
      data
    }).then(function () {
      setSuccess(true);
      setTimeout(() => {
        history.push('/meus-anuncios');
      }, 3000);
    }).catch(function (error) {
      const raw = error.response && error.response.data && error.response.data.errors;
      setErros(Array.isArray(raw) ? raw : [raw || t('pages.announcement.error')]);
      setSending(false);
    });
  }

  function mascaraTel(e) {
    if (e.length > 2) {
      e = e.replace(/\D/g, '');
      e = e.replace(/^(\d{2})(\d)/g, '($1) $2');
    }
    setPhone(e);
  }

  async function SelectCidade(city) {
    if (city.length >= 3) {
      await api.get(`/v4/search/cities?term=${city}`).then(function (response) {
        setCidades(Array.isArray(response.data) ? response.data : []);
      });
    } else {
      setCidades([]);
    }
  }

  function minhaCidade(id, nome) {
    const cid = String(id);
    const state = cid.substring(0, 2);
    setCity_code(id);
    setNomeCidade(nome);
    setState_code(state);
    setCidades([]);
  }

  function voltar() {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push('/classificados');
    }
  }

  function onFileChange(e) {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setUrlimg(URL.createObjectURL(file));
    } else {
      setUrlimg('');
    }
  }

  return (
    <FeedLayout active="classifieds">
      <div className="cadastro-anuncio-container">
        <div className="feed-top">
          <button type="button" className="btn-voltar" onClick={voltar}>
            <FiArrowLeft size={18} /> {t('pages.announcement.back')}
          </button>
          <span>{t('pages.announcement.newAd')}</span>
        </div>

        <form onSubmit={enviarAnuncio} encType="multipart/form-data">
          <div className="field">
            <div className="title">{t('pages.announcement.adTitle')}</div>
            <div className="content">
              <input
                type="text"
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="title">{t('pages.announcement.adMsg')}</div>
            <div className="content">
              <textarea
                value={mensagem}
                onChange={(e) => setMensagem(e.target.value)}
              />
            </div>
          </div>

          <div className="field">
            <div className="title">{t('pages.announcement.adDuration')}</div>
            <div className="content radios">
              <label>
                <input
                  type="radio"
                  name="annoucement_time"
                  value="15"
                  checked={String(annoucement_time) === '15'}
                  onChange={(e) => setAnnoucement_time(e.target.value)}
                />
                {t('pages.announcement.biweekly')}
              </label>
              <label>
                <input
                  type="radio"
                  name="annoucement_time"
                  value="30"
                  checked={String(annoucement_time) === '30'}
                  onChange={(e) => setAnnoucement_time(e.target.value)}
                />
                {t('pages.announcement.mounth')}
              </label>
            </div>
          </div>

          <div className="field">
            <div className="title">{t('pages.announcement.categories')}</div>
            <div className="content">
              <select
                id="tag_id"
                value={tag}
                onChange={(e) => setTag(e.target.value)}
              >
                <option value="0">{t('pages.announcement.placeholders.tags')}</option>
                {tagAn.map((item) => (
                  <option key={item.id} value={item.slug}>{item.name}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="field">
            <div className="content foto-row">
              {urlimg ? (
                <img src={urlimg} className="preview-img" alt="" />
              ) : (
                <div className="preview-empty">Foto</div>
              )}
              <input
                id="fileInput"
                className="file-chooser"
                onChange={onFileChange}
                type="file"
                accept="image/*"
              />
            </div>
          </div>

          <div className="field">
            <div className="content">
              <label className="check-video">
                <input
                  type="checkbox"
                  id="video"
                  name="video"
                  checked={has_video === 'true'}
                  onChange={(e) => setHas_video(e.target.checked ? 'true' : '')}
                />
                {t('pages.announcement.hasVideo')}
              </label>
            </div>
          </div>

          <div className="grid-2">
            <div className="field">
              <div className="title">{t('pages.announcement.phone')}</div>
              <div className="content">
                <input
                  type="tel"
                  value={phone}
                  maxLength="14"
                  onChange={(e) => setPhone(e.target.value)}
                  onKeyUp={(e) => mascaraTel(e.target.value)}
                />
              </div>
            </div>

            <div className="field city-field">
              <div className="title">{t('pages.announcement.city')}</div>
              <div className="content">
                <input
                  value={city_code}
                  onChange={(e) => setCity_code(e.target.value)}
                  id="city_id"
                  className="city_id"
                  name="city_id"
                  type="hidden"
                />
                <input
                  placeholder={t('pages.announcement.city')}
                  type="text"
                  name="cidade"
                  id="cidade"
                  value={nomeCidade}
                  onChange={(e) => {
                    setNomeCidade(e.target.value);
                    SelectCidade(e.target.value);
                  }}
                  autoComplete="off"
                />
                {cidades.length > 0 && (
                  <div className="cidades" id="dvCidades">
                    {cidades.map((cid) => (
                      <button
                        type="button"
                        key={cid.code || cid.id}
                        onClick={() => minhaCidade(cid.code, cid.value)}
                      >
                        {cid.value}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="grid-2">
            <div className="field">
              <div className="title">{t('pages.announcement.breed')}</div>
              <div className="content">
                <input
                  type="text"
                  value={livestock_race}
                  onChange={(e) => setLivestock_race(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <div className="title">{t('pages.announcement.heads')}</div>
              <div className="content">
                <input
                  type="number"
                  value={count}
                  onChange={(e) => setCount(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="grid-2">
            <div className="field">
              <div className="title">{t('pages.announcement.ageMounth')}</div>
              <div className="content">
                <input
                  type="text"
                  value={livestock_age}
                  onChange={(e) => setLivestock_age(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <div className="title">{t('pages.announcement.weight')}</div>
              <div className="content">
                <input
                  type="text"
                  value={livestock_weight}
                  onChange={(e) => setLivestock_weight(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="field">
            <div className="title">{t('pages.announcement.price')}</div>
            <div className="content valor-row">
              <input
                type="number"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
              <select
                value={count_type}
                onChange={(e) => setCount_type(e.target.value)}
              >
                <option value="fifteen_kilos">{t('pages.announcement.fifteenKilos')}</option>
                <option value="sacs">{t('pages.announcement.sacs')}</option>
                <option value="tons">{t('pages.announcement.tons')}</option>
                <option value="head">{t('pages.announcement.head')}</option>
                <option value="live_kilos">{t('pages.announcement.liveKilos')}</option>
              </select>
            </div>
          </div>

          <div className="field">
            <div className="title">{t('pages.announcement.observation')}</div>
            <div className="content">
              <textarea
                value={obs}
                onChange={(e) => setObs(e.target.value)}
              />
            </div>
          </div>

          {success && (
            <div className="message success">
              <p><strong>{t('pages.announcement.success')}</strong></p>
            </div>
          )}

          {erros.length > 0 && (
            <div className="message error">
              <p><strong>{t('pages.announcement.error')}</strong></p>
              {erros.map((err, index) => (
                <p key={index}>- {String(err)}</p>
              ))}
            </div>
          )}

          <div className="field">
            <button className="submit" id="btn-enviar" type="submit" disabled={sending}>
              {t('pages.announcement.send')}
            </button>
          </div>
        </form>
      </div>
    </FeedLayout>
  );
}
